import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Process', href: '#process' },
    { label: 'Industries', href: '#industries' },
    { label: 'Solution', href: '#solution' },
  ];

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-brand-light' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/c0a88de9-38fc-4f88-a1f1-70c076e7f78c.png"
              alt="Workflow Wizards AI"
              style={{
                width: 120,
                height: 120,
                objectFit: 'contain',
              }}
            />
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleAnchorClick(e, link.href)}
                className={`font-inter text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? 'text-brand-text hover:text-brand-violet'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="#contact"
              onClick={(e) => handleAnchorClick(e, '#hero')}
              className="whitespace-nowrap font-inter text-sm font-semibold px-5 py-2.5 rounded-lg bg-brand-violet text-white hover:bg-[#6D28D9] transition-colors duration-200 cursor-pointer"
            >
              Book a Demo
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-brand-text' : 'text-white'}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-brand-light shadow-lg">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleAnchorClick(e, link.href)}
                className="font-inter text-sm font-medium text-brand-text hover:text-brand-violet transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#hero"
              onClick={(e) => handleAnchorClick(e, '#hero')}
              className="whitespace-nowrap font-inter text-sm font-semibold px-5 py-2.5 rounded-lg bg-brand-violet text-white text-center cursor-pointer"
            >
              Book a Demo
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
